import PropTypes from 'prop-types'
import { bowserFlags } from 'lib/bowser'
import { Col, Row } from 'react-bootstrap'
import { map } from 'lodash'
import classNames from 'classnames'
import * as blUrls from 'lib/urls'
import PageAnimation from 'components/page-animation'

import SideNav from 'components/side-nav'
import css from './post-list-view.scss'
import { getActiveSlugSet } from '../../reducers'
import PregnancyWeekSelect from '../pregnancy-week-select'
import { SectionHeading } from '../../../components/headings'

const PostListView = ({
  title,
  topicSlug,
  posts,
  topicNavigation,
  description,
  children,
}) => {
  const navCategory = { title: 'Home', path: '/hello-baby', urlSlug: null }
  const sideNavTree = map(topicNavigation.items, (topic) => ({
    title: topic.name,
    urlSlug: topic.slug,
    children: map(topic.children, (topic) => ({
      title: topic.name,
      urlSlug: topic.slug,
      path: blUrls.helloBabyPostPath(topic.slug),
    })),
    path: blUrls.helloBabyPostPath(topic.slug),
  }))

  return (
    <div className="container">
      <Row>
        <Col
          key={`${topicSlug}-header`}
          sm={12}
          className={classNames(
            css.titleContainer,
            'flex-vertical-center-sm mvl'
          )}
        >
          <div className="full-width text-center">
            <SectionHeading>{title}</SectionHeading>
            {description ? <div className="h5">{description}</div> : null}
            {topicSlug === 'pregnancy-week-by-week' ? (
              <PregnancyWeekSelect posts={posts} className="inline-block" />
            ) : null}
          </div>
        </Col>
        {!bowserFlags.mobile && (
          <Col sm={3} className={css.sidenav}>
            <SideNav
              sidebarTitle="Guides"
              navCategory={navCategory}
              categoryTree={sideNavTree || []}
              activeSlugSet={getActiveSlugSet(topicSlug, topicNavigation)}
            />
          </Col>
        )}
        <Col sm={9} className="ptm mts">
          <PageAnimation>
            <div key={topicSlug} className={css.contentContainer}>
              {children}
            </div>
          </PageAnimation>
        </Col>
      </Row>
    </div>
  )
}

PostListView.propTypes = {
  posts: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  topicSlug: PropTypes.string.isRequired,
  topicNavigation: PropTypes.object.isRequired,
  emailUrls: PropTypes.object,
}

export default PostListView
